// MessageCategoryMore.jsx
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import BrowseTab from '../container/BrowseTab.js';
import CategoryGroupContainer from '../container/CategoryGroup.js';
import CategoryGroupComponent from '../component/CategoryGroup.jsx';
import withRouter from '../component/WithRouter.jsx';
import SeoLongDescription from '../component/SeoLongDescription.jsx';
import getTranslationKey from '../resource/getTranslationKey.js';
import media from '../style/media.js';
import { headerHeight, color } from '../style/variables.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

class MessageCategoryMore extends PureComponent {
  componentDidMount() {
    const { fetchFeeds, trendingCategoryFeed, fetchLimit } = this.props;
    fetchFeeds({
      type: trendingCategoryFeed,
      limit: fetchLimit,
      page: 1,
    });
  }
  render() {
    const { t, categoryGroups, trendingCategories } = this.props;

    const headerTitle = t('category_title', { ns: TranslationNamespace.FEED });

    const categoryOverviewIntroKey = getTranslationKey({
      key: 'seo_overview_category_intro',
    });
    const categoryOverviewIntro = t(categoryOverviewIntroKey, {
      ns: TranslationNamespace.SEO,
    });

    const longDescriptionKey = getTranslationKey({
      key: 'seo_overview_category_long_description',
    });
    const longDescription = t(longDescriptionKey, {
      ns: TranslationNamespace.SEO,
    });
    return (
      <Container>
        <BrowseTab />
        <Body>
          <HeaderText>{headerTitle}</HeaderText>
          <Description content={categoryOverviewIntro} clampLines={1} />
          <CategoryGroupComponent
            title={t('trending_category', {
              ns: TranslationNamespace.FEED,
            })}
            categoryItems={trendingCategories}
            isInOverview={true}
          />
          {categoryGroups.map(group => (
            <CategoryGroupContainer
              key={group}
              groupName={group}
              isInOverview={true}
            />
          ))}
          <LongDescriptionWrapper>
            <SeoLongDescription
              content={longDescription}
              clampLines={1}
              noSpaceWithContent
            />
          </LongDescriptionWrapper>
        </Body>
      </Container>
    );
  }
}

MessageCategoryMore.propTypes = {
  fetchFeeds: PropTypes.func,
  t: PropTypes.func.isRequired,
  trendingCategoryFeed: PropTypes.string,
  fetchLimit: PropTypes.number,
  categoryGroups: PropTypes.array,
  trendingCategories: PropTypes.array,
};

MessageCategoryMore.defaultProps = {
  fetchFeeds: () => null,
  trendingCategoryFeed: '',
  fetchLimit: 15,
  categoryGroups: [],
  trendingCategories: [],
};

const Container = styled.div`
  position: relative;
  margin: calc(var(--space-to-pinned-notification) + ${headerHeight}px) auto 0;
  width: 960px;

  border-right: 1px solid var(--background-color-secondary-on-dark, #232323);
  border-left: 1px solid var(--background-color-secondary-on-dark, #232323);
  background-color: var(--background-color-primary-on-dark, #191919);

  ${media.tablet`
    width: 682px;
  `};
  ${media.mobile`
    width: 100%;
    border-right: unset;
    border-left: unset;
  `};
`;

const Body = styled.div`
  padding: 32px 16px 32px;
  ${media.mobile`
    padding-top: 32px;
  `}
`;

const HeaderText = styled.h1`
  font-size: 22px;
  font-weight: 600;
  line-height: 150%;
  margin: 0 0 8px;
  padding: 0;
  letter-spacing: 0.022px;
  color: ${color.white};
`;

const Description = styled(SeoLongDescription)`
  padding-bottom: 16px;
  ${media.mobile`
    padding-bottom: 24px;
  `};
`;

const LongDescriptionWrapper = styled.div`
  max-width: 960px;
  width: 100%;
  padding-top: 8px;
  ${media.tablet`
    padding: 8px 16px 0;
  `};
`;

export default withTranslation()(withRouter(MessageCategoryMore));
